const msgleaveRouter = {
  path: '/msgleave',
  component: () => import('@/views/cms/slider/index'), // Parent router-view
  name: 'MsgLeave',
  meta: {
    title: '留言线索管理',
    icon: 'el-icon-postcard',
    roles: ['root', 'market', 'business']
  },
  children: [
    {
      path: 'table',
      name: 'MsgLeaveTable',
      component: () => import('@/views/cms/msgleave/table'),
      meta: { title: '留言线索管理', icon: 'el-icon-s-comment', roles: ['root', 'market', 'business'], noCache: false }
    }
  ]
}
export default msgleaveRouter
